import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";
import { cn } from "@/lib/utils";

const LINES = [
  { who: "You", end: 6.4, text: "Honestly, I'm exhausted. Forty applications and almost no replies. Can you help me rebuild my confidence?" },
  { who: "Coach", end: 999, text: "Of course. Forty applications is real effort, and you booked two interviews this month, so it's working. Let's pick one small win for today…" },
];

// Short voice sample of the Career Companion (static mp3 in /public/promo).
export const CompanionAudio = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [t, setT] = useState(0);
  const [dur, setDur] = useState(0);
  useEffect(() => () => ref.current?.pause(), []);
  const toggle = (e) => { e.stopPropagation(); const a = ref.current; if (!a) return; if (a.paused) a.play().catch(() => {}); else a.pause(); };
  const cur = t > 0 ? (t < LINES[0].end ? 0 : 1) : -1;
  return (
    <div className="rounded-2xl border border-[#A855F7]/40 bg-gradient-to-br from-[#1a0b2e] to-[#0f0a17] p-3" data-testid="companion-audio">
      <audio ref={ref} src="/promo/companion.mp3" preload="metadata" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onEnded={() => { setPlaying(false); setT(0); }}
        onTimeUpdate={(e) => setT(e.currentTarget.currentTime)} onLoadedMetadata={(e) => setDur(e.currentTarget.duration || 0)} />
      <div className="flex items-center gap-3">
        <button onClick={toggle} className="trial-glow flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#A855F7] text-white transition-transform hover:scale-105" aria-label={playing ? "Pause sample" : "Play sample"} data-testid="companion-audio-play">
          {playing ? <Pause className="h-4 w-4" /> : <Play className="ml-0.5 h-4 w-4" />}
        </button>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold text-[#E9D5FF]">Hear the Voice Career Companion</p>
          <div className="mt-1.5 flex h-5 items-center gap-[3px]" aria-hidden>
            {Array.from({ length: 28 }).map((_, i) => (
              <span key={i} className={cn("w-[3px] rounded-full", dur && i / 28 <= t / dur ? "bg-[#C084FC]" : "bg-zinc-700")}
                style={{ height: `${30 + ((i * 37) % 70)}%`, animation: playing ? `tour-wave ${0.7 + (i % 5) * 0.12}s ease-in-out ${i * 0.04}s infinite` : "none" }} />
            ))}
          </div>
        </div>
        <span className="shrink-0 font-mono text-[10px] text-zinc-500" data-testid="companion-audio-time">{Math.floor(t)}s{dur ? ` / ${Math.round(dur)}s` : ""}</span>
      </div>
      <div className="mt-2.5 space-y-1">
        {LINES.map((l, i) => (
          <p key={l.who} className={cn("text-[11px] leading-snug transition-colors", cur === i ? "text-zinc-100" : "text-zinc-500")} data-testid={`companion-line-${i}`}>
            <span className={cn("mr-1 font-semibold", i ? "text-[#C084FC]" : "text-[#F3C649]")}>{l.who}:</span>{l.text}
          </p>
        ))}
      </div>
    </div>
  );
};
